import React, { useEffect } from 'react';
import { useHistory } from 'react-router';
import { useSelector, useDispatch } from 'react-redux';
import Grid from '@material-ui/core/Grid';
// import Table from '@material-ui/core/Table';
// import TableBody from '@material-ui/core/TableBody';
// import TableCell from '@material-ui/core/TableCell';
// import TableContainer from '@material-ui/core/TableContainer';
// import TableHead from '@material-ui/core/TableHead';
// import TableRow from '@material-ui/core/TableRow';
// import Paper from '@material-ui/core/Paper';

import TotalEmpCoreTeam from '../../../components/totalEmpCoreTeam';
import IndividualClients from '../../../components/individualClients';
import CorpClients from '../../../components/corpClients';

import AdminPendingInvoices from '../../../components/adminPendingInvoices/index';
import AdminPendingPayments from '../../../components/adminPendingPayments/index';
import AdminRenameTeam from '../../../components/adminRenameTeam/index';
import AdminViewPayments from '../../../components/adminViewPayments/index';
import AdminRazorPay from '../../../components/adminRazorPay/index';

import useStyles from '../styles/index';

import { getIMCclientDetails } from '../../users/store/actions/index';

function AdminDashboard(props) {
    const classes = useStyles();
    const history = useHistory();
    const dispatch = useDispatch({});

    const imcclients = useSelector((state) => state.users.imcClients);
    const imcvalues = imcclients && imcclients.content;

    useEffect(() => {
        history.push({
            state: { breadCrumbLabel: props.breadCrumbLabel, breadCrumbPath: props.breadCrumbPath },
        });
        dispatch(getIMCclientDetails());
    }, []);

    return (
        <div className={classes.dashboardmaindiv}>
            <Grid container spacing={3}>
                <Grid item sm={6} xs={12}>
                    {/* <PendingInvoices /> */}
                    {/* <PendingPayment /> */}
                    <IndividualClients />
                    {/* <CorporateClients /> */}
                </Grid>
                <Grid item sm={6} xs={12}>
                    <CorpClients />
                    {/* <TotalImcEmp /> */}
                </Grid>
                {/* <Grid item sm={12} xs={12}>
                    <div className={classes.imcTable}>
                        <div className={classes.imcHeading}>
                            <h2>Intermediary Clients </h2>
                        </div>
                        <TableContainer component={Paper} className={classes.tablemaincontainer}>
                            <Table className={classes.table} stickyHeader aria-label="sticky table">
                                <TableHead>
                                    <TableRow>
                                        <TableCell className={classes.imctableheading}>Name of the entity</TableCell>
                                        <TableCell className={classes.imctableheading} align="left">
                                            GSTIN
                                        </TableCell>
                                        <TableCell className={classes.imctableheading} align="left">
                                            Admin email id
                                        </TableCell>
                                        <TableCell className={classes.imctableheading} align="left">
                                            Domain name
                                        </TableCell>
                                        <TableCell className={classes.imctableheading} align="left">
                                            Admin mobile number
                                        </TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {imcvalues &&
                                        imcvalues.map((row, index) => (
                                            <TableRow key={Math.random()}>
                                                <TableCell className={classes.imctableBody} component="th" scope="row">
                                                    {row.intClientName}
                                                </TableCell>
                                                <TableCell className={classes.imctableBody} align="left">
                                                    {row.gstIn}
                                                </TableCell>
                                                <TableCell className={classes.imctableBody} align="left">
                                                    {row.adminEmail}
                                                </TableCell>
                                                <TableCell className={classes.imctableBody} align="left">
                                                    {row.dbName}
                                                </TableCell>
                                                <TableCell className={classes.imctableBody} align="left">
                                                    {row.adminMobile}
                                                </TableCell>
                                            </TableRow>
                                        ))}
                                </TableBody>
                            </Table>
                        </TableContainer> 
                    </div>
                </Grid> */}
                <Grid item sm={3} xs={12}>
                    <TotalEmpCoreTeam />
                </Grid>
                <Grid item sm={3} xs={12}>
                    <AdminPendingInvoices />
                </Grid>
                <Grid item sm={3} xs={12}>
                    <AdminRenameTeam />
                </Grid>
                <Grid item sm={3} xs={12}>
                    <AdminViewPayments />
                </Grid>
                {/* <Grid item sm={3} xs={12}>
                    <AdminRazorPay />
                </Grid> */}
            </Grid>
        </div>
    );
}

export default AdminDashboard;
